import { render } from "./ConfirmBox.vue?vue&type=template&id=b87b6af6&scoped=true&lang=pug"
import script from "./ConfirmBox.vue?vue&type=script&lang=js"
export * from "./ConfirmBox.vue?vue&type=script&lang=js"

import "./ConfirmBox.vue?vue&type=style&index=0&id=b87b6af6&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87b6af6"]])

export default __exports__